import { put, takeEvery, call } from "redux-saga/effects";
import requestWithSubTenantIfNeeded from "../requestWithSubTenantIfNeeded";
import * as actions from "./membersGetActions";
import { parseDateString, formatDateString } from "safervpn-storybook/src/tools/date";
import { DEFAULT_QUERY } from "@p81-common/shell-core-js";

function formatDate(name, date) {
  return {
    [`${name}FormattedDate`]: date && formatDateString(date, "without-time"),
    [`${name}FormattedTime`]: date && formatDateString(date, "only-time"),
    [`${name}Parsed`]: date && parseDateString(date),
  };
}

let blockedIcon =
  'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" width="16px" height="16px" style="background-color: rgb(213, 215, 223)"><path fill-rule="evenodd" fill="rgb(83, 98, 131)" d=" M 6.09 6.16 C 6.09 5.105 6.945 4.25 8 4.25 C 9.055 4.25 9.91 5.105 9.91 6.16 L 9.91 6.902 C 10.018 6.902 10.114 6.902 10.206 6.902 C 10.693 6.918 11.132 7.202 11.346 7.64 C 11.427 7.808 11.473 7.991 11.481 8.178 C 11.481 8.371 11.481 8.603 11.481 8.888 L 11.481 9.765 C 11.481 10.05 11.481 10.303 11.481 10.475 C 11.473 10.661 11.427 10.844 11.346 11.013 C 11.212 11.271 11.002 11.481 10.744 11.615 C 10.575 11.696 10.392 11.742 10.206 11.75 C 10.018 11.75 9.786 11.75 9.496 11.75 L 6.504 11.75 C 6.214 11.75 5.966 11.75 5.794 11.75 C 5.608 11.742 5.425 11.696 5.256 11.615 C 5 11.486 4.79 11.281 4.654 11.029 C 4.573 10.861 4.527 10.678 4.519 10.491 C 4.519 10.297 4.519 10.066 4.519 9.781 L 4.519 8.904 C 4.519 8.619 4.519 8.366 4.519 8.194 C 4.535 7.706 4.818 7.268 5.256 7.053 C 5.426 6.98 5.609 6.942 5.794 6.94 C 5.886 6.94 5.982 6.94 6.09 6.94 L 6.09 6.16 Z  M 9.27 6.16 L 9.27 6.902 L 6.73 6.902 L 6.73 6.16 C 6.73 5.459 7.299 4.89 8 4.89 C 8.701 4.89 9.27 5.459 9.27 6.16 Z  M 5.848 7.553 C 5.746 7.557 5.646 7.579 5.552 7.618 C 5.309 7.732 5.155 7.979 5.159 8.247 C 5.159 8.409 5.159 8.613 5.159 8.92 L 5.159 9.765 C 5.159 10.071 5.159 10.276 5.159 10.437 C 5.155 10.706 5.309 10.952 5.552 11.067 C 5.646 11.106 5.746 11.128 5.848 11.131 C 6.015 11.131 6.219 11.131 6.52 11.131 L 9.49 11.131 C 9.792 11.131 9.996 11.131 10.163 11.131 C 10.265 11.128 10.365 11.106 10.459 11.067 C 10.702 10.952 10.856 10.706 10.852 10.437 C 10.852 10.276 10.852 10.071 10.852 9.765 L 10.852 8.92 C 10.852 8.613 10.852 8.409 10.852 8.247 C 10.856 7.979 10.702 7.732 10.459 7.618 C 10.362 7.577 10.257 7.555 10.152 7.553 C 9.985 7.553 9.781 7.553 9.48 7.553 L 6.515 7.553 C 6.214 7.537 6.009 7.537 5.848 7.553 Z  M 8.355 9.63 C 8.63 9.47 8.763 9.145 8.68 8.837 C 8.597 8.53 8.318 8.317 8 8.317 C 7.682 8.317 7.403 8.53 7.32 8.837 C 7.237 9.145 7.37 9.47 7.645 9.63 L 7.645 10.254 C 7.645 10.45 7.804 10.609 8 10.609 C 8.196 10.609 8.355 10.45 8.355 10.254 L 8.355 9.63 Z "/></svg>';

export function formatMember(x) {
  if (x.bruteForceBlocked) {
    x.icon = {
      url: blockedIcon,
    };
  }
  return {
    ...x,
    fullName: x.firstName && `${x.firstName} ${x.lastName || ""}`,
    sortingName: x.emailVerified ? `${x.firstName} ${x.lastName}` : x.email,
    ...formatDate("lastLoginAt", x.lastVPNSuccessLoginAt),
    ...formatDate("createdAt", x.createdAt),
  };
}

function makePartialSearchParams(params) {
  if (params.q) {
    let result = { ...params };
    result.q = JSON.stringify({
      fullName: params.q,
      email: params.q,
    });
    result.qType = "partial";
    return result;
  }
  return params;
}

function* membersGet(action) {
  let { searchParams = DEFAULT_QUERY, resolve, reject } = action;
  try {
    let response = yield requestWithSubTenantIfNeeded("get", "members", {
      searchParams: makePartialSearchParams(searchParams),
    });

    let actualData = response.data;
    let fullData = {
      ...actualData.members,
      data: actualData.members.data.map(formatMember),
    };

    yield put(actions.requestSuccess(fullData));
    if (resolve) {
      yield call(resolve, fullData);
    }
  } catch (error) {
    yield put(actions.requestFailure(error));
    if (reject) {
      yield call(reject, error);
    }
  }
}

function* saga() {
  yield takeEvery(actions.MEMBERS_GET_REQUEST, membersGet);
}

export default saga;
